export default __webpack_public_path__ + "img/dd17db1dc41b13a5e09d3176a5f28af4.svg";